import { Component } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatToolbarModule } from '@angular/material/toolbar';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { CarItemComponent } from '../../components/car-item/car-item.component';
import { CarStatItemComponent } from '../../components/car-stat-item/car-stat-item.component';
import { DividerComponent } from '../../components/divider/divider.component';
import { CarApiService } from '../../services/car-api.service';
@Component({
  selector: 'app-car-page',
  imports: [
    MatToolbarModule,
    MatIconModule,
    MatButtonModule,
    RouterModule,
    MatProgressSpinnerModule,
    MatDividerModule,
    CarItemComponent,
    DividerComponent,
    CarStatItemComponent,
  ],
  templateUrl: './car-page.component.html',
  styleUrl: './car-page.component.scss',
})
export class CarPageComponent {
  id: number = 0;
  data: any;
  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private carApi: CarApiService,
    private title: Title
  ) {
    this.route.params.subscribe((r) => {
      this.id = parseInt(r['id']);
      this.getCar();
    });
  }

  get carname() {
    if (!this.data) {
      return '';
    }
    return `${this.data.year} ${this.data.name}`;
  }

  loading: boolean = false;
  async getCar() {
    try {
      this.loading = true;
      this.data = await this.carApi.getCar(this.id);
      this.title.setTitle(`${this.carname} - Forza Horizon 5 Cars`);
    } catch (error) {
    } finally {
      this.loading = false;
    }
  }
}
